/**
 * Matches automáticos (motor SQL determinista del backend).
 */
import { api } from "./client";

export interface MatchUser {
  id: number;
  name: string;
  handle: string | null;
  city: string | null;
  country: string;
  region: string | null;
  avatar_color: string;
  initials: string;
  verified: boolean;
  stars_avg: number;
  trades_completed: number;
  level: number;
}

export interface MatchEntry {
  user: MatchUser;
  score: number;
  i_give_count: number;
  you_give_count: number;
  i_give_sticker_ids: number[];
  you_give_sticker_ids: number[];
}

export async function fetchMatches(limit = 50): Promise<MatchEntry[]> {
  return api<MatchEntry[]>(`/matches?limit=${limit}`);
}
